<template>
  <div class="title-container">
    <a :href="domain">
      <img :src="darkTheme === 'dark' ? darkLogo : svgLogo" />
    </a>
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useConfig } from '@/hooks/useConfig'
import { useLogo } from '@/hooks/useLogo'
import { darkTheme } from '@/utils/helpers'

export default defineComponent({
  name: 'TitleContainer',
  props: {
    link: {
      type: String
    }
  },
  setup: () => {
    const { svgLogo } = useLogo()
    const { darkLogo } = useLogo()
    const { domain } = useConfig()

    return { svgLogo, darkLogo, domain, darkTheme }
  }
})
</script>
<style lang="scss" scoped>
img {
  max-height: 200px;
  width: 100%;
}
</style>
